import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

const ThemeContextProvider = (props) => {
  const [theme, setTheme] = useState({
    label: localStorage.getItem('theme') || 'Dark',
    isThemeAuto: false,
    header: {
      text: '#ececec',
      bg: '#001529',
    },
    content: {
      text: '#ececec',
      bg: '#1c1c1c',
      secondaryText: '#bfbfbf',
    },
    drawer: {
      text: '#ececec',
      bg: '#1c1c1c',
      divider: '#dcdcdc',
    },
    footer: {
      text: '#ececec',
      bg: '#161616',
    },
  });

  const changeTheme = (type) => {
    localStorage.setItem('theme', type);
    document.querySelector('body').style.backgroundColor =
      type === 'dark' ? '#1c1c1c' : '#ffffff';
    const isThemeAuto = localStorage.getItem('theme_type') === 'auto';
    switch (type) {
      case 'dark':
        setTheme({
          isThemeAuto,
          isMobile: isMobile(),
          label: 'Dark',
          header: {
            text: '#ffffff',
            bg: '#0062be',
          },
          content: {
            text: '#ffffff',
            bg: '#1c1c1c',
            secondaryText: '#bfbfbf',
          },
          drawer: {
            text: '#ffffff',
            secondaryText: '#bfbfbf',
            bg: '#1c1c1c',
          },
          footer: {
            text: '#ffffff',
            bg: '#161616',
          },
        });
        break;
      case 'light':
        setTheme({
          isThemeAuto,
          isMobile: isMobile(),
          label: 'Light',
          header: {
            text: '#fff',
            bg: '#1890ff',
          },
          content: {
            text: '#1c1c1c',
            bg: '#ffffff',
            secondaryText: '#C2C2C2',
          },
          drawer: {
            text: '',
            bg: '',
          },
          footer: {
            text: '#1c1c1c',
            bg: '#ececec',
          },
        });
        break;

      default:
        break;
    }
  };

  const updateAutoTheming = (type) => {
    localStorage.setItem('theme_type', type);
    setTheme({
      isThemeAuto: type === 'auto',
    });
    const hours = new Date().getHours();
    if (hours > 6 && hours < 18) {
      changeTheme('light');
    } else {
      changeTheme('dark');
    }
  };

  const isMobile = () => {
    let hasTouchScreen = false;
    if ('maxTouchPoints' in navigator) {
      hasTouchScreen = navigator.maxTouchPoints > 0;
    } else if ('msMaxTouchPoints' in navigator) {
      hasTouchScreen = navigator.msMaxTouchPoints > 0;
    } else {
      const mQ = window.matchMedia && matchMedia('(pointer:coarse)');
      if (mQ && mQ.media === '(pointer:coarse)') {
        hasTouchScreen = !!mQ.matches;
      } else if ('orientation' in window) {
        hasTouchScreen = true; // deprecated, but good fallback
      } else {
        // Only as a last resort, fall back to user agent sniffing
        const UA = navigator.userAgent;
        hasTouchScreen =
          /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
          /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
      }
    }
    return hasTouchScreen;
  };

  useEffect(() => {
    const currentTheme = localStorage.getItem('theme');
    const isThemeAuto = localStorage.getItem('theme_type') === 'auto';
    console.log(`isThemeAuto`, isThemeAuto, currentTheme);
    if (isThemeAuto) {
      const hours = new Date().getHours();
      console.log(`hours`, hours);
      if (hours > 6 && hours < 18) {
        changeTheme('light');
      } else {
        changeTheme('dark');
      }
    } else if (currentTheme) {
      changeTheme(currentTheme);
    } else {
      changeTheme('light');
      localStorage.setItem('theme', 'light');
    }
  }, []);

  return (
    <ThemeContext.Provider
      value={{
        theme,
        setTheme,
        changeTheme,
        updateAutoTheming,
      }}
    >
      {props.children}
    </ThemeContext.Provider>
  );
};

export default ThemeContextProvider;
